import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ServiceLayersListItem from './ServiceLayersListItem'
import LayerGroupControl from './LayerGroupControl'

const styles = theme => ({
  card: {
    maxWidth: 400,
    marginTop: 5
  },
  media: {
    height: 194
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  flexGrow: {
    flex: '1 1 auto'
  }
})

class ServiceLayersList extends PureComponent {
  render () {
    const { service, handleLayerToggled, layersRendered } = this.props

    return (
      <List>
        {service.layers.map((layer, index) => {
          if (layer.type == 'group') {
            return <LayerGroupControl
                       key={index}
                       layerGroup={layer.layers}
                       handleLayerToggled={handleLayerToggled}
                       layersRendered={layersRendered}
                       layer={layer}
                       />
          }
          return (
            <ServiceLayersListItem
              layer={layer}
              key={index}
              handleLayerToggled={handleLayerToggled}
              layersRendered={layersRendered}
            />
          )})}
      </List>
    )
  }
}

export default withStyles(styles)(ServiceLayersList)



// WEBPACK FOOTER //
// ./src/components/ServiceLayersList.js